import { render } from "./DetalleDocumento.vue?vue&type=template&id=6673bf7a&scoped=true"
import script from "./DetalleDocumento.vue?vue&type=script&lang=js"
export * from "./DetalleDocumento.vue?vue&type=script&lang=js"

import "./DetalleDocumento.vue?vue&type=style&index=0&id=6673bf7a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6673bf7a"]])

export default __exports__